<template>
  <div>
    <div class="ir-sub-menu">
      <ul class="col3">
        <li>
          <a href="/ir/stock">株式情報</a>
        </li>
        <li>
          <a href="/ir/meeting">株主総会</a>
        </li>
        <li>
          <a href="/ir/stock_quotations" class="selected">株価情報</a>
        </li>
      </ul>
    </div>
    <section>
      <div class="l-service">
        <div class="l-service-header">
          <h2 class="heading-default heading-default-center">株価情報</h2>
          <h3 class="heading-small heading-small-center heading-small-mt-sp">
            STOCK QUOTE
          </h3>

          <div class="l-service-content-inner" style="text-align: center">
            <p>
              下記リンクよりご確認ください。※外部サイト（日経会社情報）へ遷移いたします。
            </p>
            <br />
            <a
              href="http://www.nikkei.com/nkd/company/?scode=6548 "
              target="_blank"
              class="table-branch-link"
              >（株）旅工房【6548】：株式/株価 - 日本経済新聞</a
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "株価情報",
      titleTemplate: "株価情報 | 株式について | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
